import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-2 text-lg"
}
const _hoisted_2 = {
  key: 1,
  class: "h-screen"
}
const _hoisted_3 = { class: "px-5" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_5 = { class: "flex h-full w-full items-center justify-center justify-items-center space-x-4" }
const _hoisted_6 = {
  key: 1,
  class: "my-3 flex flex-col items-center justify-center justify-items-center space-y-2"
}
const _hoisted_7 = { class: "text-2xl font-semibold" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "pt-4 text-sm" }
const _hoisted_10 = {
  key: 2,
  class: "mb-5 grid grid-cols-1 gap-4 text-sm sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5",
  style: {"grid-template-columns":"repeat(auto-fit, minmax(200px, 1fr))"}
}
const _hoisted_11 = {
  key: 0,
  class: "ShadowStyle flex flex-col items-center justify-center rounded bg-white p-1 text-center"
}
const _hoisted_12 = {
  key: 1,
  class: "ShadowStyle flex flex-col items-center justify-center rounded bg-white p-1 text-center"
}
const _hoisted_13 = { class: "ShadowStyle flex flex-col rounded bg-white p-1 text-center" }
const _hoisted_14 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_15 = { class: "flex items-center justify-center gap-1" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "text-xs font-semibold text-red-500"
}
const _hoisted_18 = {
  key: 2,
  class: "rounded bg-white p-1 text-center shadow"
}
const _hoisted_19 = { class: "flex items-center justify-center gap-1 align-middle" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 3,
  class: "rounded bg-white p-1 text-center shadow"
}
const _hoisted_22 = { class: "flex items-center justify-center gap-1 align-middle" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 4,
  class: "rounded bg-white p-1 text-center shadow"
}
const _hoisted_25 = { class: "flex items-center justify-center gap-1 align-middle" }
const _hoisted_26 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_dx_date_box = _resolveComponent("dx-date-box")!
  const _component_TheButton = _resolveComponent("TheButton")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DeviceRecordChart = _resolveComponent("DeviceRecordChart")!
  const _component_DeviceMap = _resolveComponent("DeviceMap")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": true,
    "is-full-screen-modal": true,
    "need-for-scroll": true,
    "remove-outside-click": true,
    title: `Asset details`,
    onToggleModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('closeModal', true)))
  }, {
    default: _withCtx(() => [
      (!_ctx.isLoading && !_ctx.haveData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " There is no data for choosen device "))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_Loader)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loadedData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_dx_date_box, {
                  modelValue: _ctx.from,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.from) = $event)),
                  height: 42,
                  "show-clear-button": true,
                  "display-format": _ctx.$t('LocaleFormats.formatDateBox'),
                  type: "datetime"
                }, null, 8, ["modelValue", "display-format"]),
                _createVNode(_component_dx_date_box, {
                  modelValue: _ctx.to,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.to) = $event)),
                  height: 42,
                  "show-clear-button": true,
                  "display-format": _ctx.$t('LocaleFormats.formatDateBox'),
                  type: "datetime"
                }, null, 8, ["modelValue", "display-format"]),
                _createVNode(_component_TheButton, {
                  text: 'Refresh',
                  class: "delete-button my-1 flex h-10 w-24 items-center justify-center border",
                  size: "sm",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getDeviceData()))
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.loadedData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.deviceName), 1),
              _createElementVNode("img", {
                src: _ctx.IconSelector(_ctx.deviceTypeId as number),
                class: "h-[8rem] w-[8rem]"
              }, null, 8, _hoisted_8),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.devices[0].data[0].dateTime), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.loadedData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.deviceTypeId == 28)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "font-semibold" }, "Total", -1)),
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.devices[0].data[0].payload.countFwd / 1000) + " m", 1),
                      _cache[5] || (_cache[5] = _createElementVNode("sup", null, "3", -1))
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.devices[0].data[0].payload.countFwd) + " l", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.deviceTypeId == 28)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "font-semibold" }, "Measuring spot number", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.devices[0].data[0].payload.spotNum), 1)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices[0].data[0].payload.records, (record) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (record.value > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(record.idName), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'circle'],
                      style: _normalizeStyle({ color: record.hexColor })
                    }, null, 8, ["style"]),
                    (record.value > 0)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: _normalizeClass({
                'text-red-500':
                  record.value < record.minValue ||
                  record.value > record.maxValue,
              })
                        }, [
                          _createTextVNode(_toDisplayString(record.value.toFixed(2)) + " ", 1),
                          (record.unitSymbol)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(record.unitSymbol), 1))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  (record.isValid == false)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Not valid "))
                    : _createCommentVNode("", true)
                ], 512)), [
                  [_vShow, record.value > 0]
                ])
              }), 256)),
              (_ctx.devices[0].data[0].payload.sensor1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "font-semibold" }, "T1", -1)),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-4xl font-extrabold text-[#125a18]" }, "•", -1)),
                      (_ctx.devices[0].data[0].payload.sensor1 > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.devices[0].data[0].payload.sensor1) + " °C ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.devices[0].data[0].payload.sensor2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _cache[11] || (_cache[11] = _createElementVNode("p", { class: "font-semibold" }, "T2", -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-4xl font-extrabold text-[#ffb03b]" }, "•", -1)),
                      (_ctx.devices[0].data[0].payload.sensor2 > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.devices[0].data[0].payload.sensor2) + " °C ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.devices[0].data[0].payload.sensor3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "font-semibold" }, "T3", -1)),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-4xl font-extrabold text-[#644311]" }, "•", -1)),
                      (_ctx.devices[0].data[0].payload.sensor3 > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.devices[0].data[0].payload.sensor3) + " °C ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.loadedData)
          ? (_openBlock(), _createBlock(_component_DeviceRecordChart, {
              key: 3,
              deviceData: _ctx.devices,
              deviceTypes: _ctx.deviceTypeConfigurations,
              rangeData: _ctx.deviceDataRange
            }, null, 8, ["deviceData", "deviceTypes", "rangeData"]))
          : _createCommentVNode("", true),
        (_ctx.loadedData)
          ? (_openBlock(), _createBlock(_component_DeviceMap, {
              key: 4,
              class: "mt-3",
              deviceAssignments: _ctx.deviceAssignments,
              deviceData: _ctx.devices,
              deviceTypes: _ctx.deviceTypeConfigurations,
              deviceMetadata: _ctx.metadataMap,
              onChangeName: _ctx.changeName,
              onSaveChanges: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveChanges()))
            }, null, 8, ["deviceAssignments", "deviceData", "deviceTypes", "deviceMetadata", "onChangeName"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}